import React from 'react';
import PropTypes from 'prop-types';
import i18next from 'i18next';

import withMedia from '~/modules/core/utils/mediaHelpers/withMedia';
import { currentCurrencyDisplayName } from '~/modules/ecommerceCore/utils/changeCurrency';
import ExternalLink from '~/modules/coreUI/components/basic/ExternalLink';

import {
  StartFrom,
  PriceNumber,
  Currency,
  OldPrice,
  Status,
} from '~/modules/ecommerceCoreUI/components/basic/Labels';

import { Row, Column } from '~/modules/coreUI/components/layouts/helpers/LinearLayout';

const Price = props => (
  <Column leftAligned spaceBetween={0.5}>
    {props.showStartFromLabel && (
      <Row leftJustified fullWidth>
        <StartFrom>{i18next.t('ecommerceCoreUI:Product.startFrom')}</StartFrom>
      </Row>
    )}
    <Row spaceBetween={0.5} nowrap>
      <PriceNumber media={props.media} mobileCard={props.mobileCard}>
        {props.price}
      </PriceNumber>
      <Currency mobileCard={props.mobileCard}>{currentCurrencyDisplayName()}</Currency>
    </Row>
    {!!props.oldPrice && (
      <Row nowrap rightJustified={!props.mobileCard} leftJustified={props.mobileCard} fullWidth>
        <OldPrice mobileCard={props.mobileCard}>
          {props.oldPrice}
          {' '}
          {currentCurrencyDisplayName()}
        </OldPrice>
      </Row>
    )}
    {props.taxStatus === 'taxes_not_included' ? (
      <Row rightJustified={!props.mobileCard} leftJustified={props.mobileCard} fullWidth>
        <ExternalLink url="/terms_conditions/stp/" target="_blank">
          <Status>{i18next.t('ecommerceCoreUI:Product.taxesNotIncluded')}</Status>
        </ExternalLink>
      </Row>
    ) : null}
  </Column>
);

Price.defaultProps = {
  oldPrice: null,
  taxStatus: '',
  showStartFromLabel: false,
  mobileCard: false,
  media: null,
};

Price.propTypes = {
  price: PropTypes.number.isRequired,
  oldPrice: PropTypes.number,
  taxStatus: PropTypes.string,
  media: PropTypes.shape({}),
  showStartFromLabel: PropTypes.bool,
  mobileCard: PropTypes.bool,
};

export default withMedia(Price);
